module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/badanie-techniczne-white-5f1cb09c.svg";